/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface FiltersResetProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
const FiltersReset: React.SFC<FiltersResetProps> = ({size, ...props}) => (
  <svg viewBox="0 0 14 14" fill="currentColor" width={ size || "1em" } height={ size || "1em" } {...props}>
    <path d="M1.803 4a6 6 0 11-.72 4H.071A7.002 7.002 0 0014 7 7 7 0 001 3.392V0H0v5h5V4H1.803z" fillRule="evenodd" />
  </svg>
);
FiltersReset.displayName = 'FiltersReset';
export default FiltersReset;
/* tslint:enable */
/* eslint-enable */
